module.exports = __webpack_public_path__ + "img/A0A8B0_424336_E7E9EF_545C5C-256px.0097e1d5.png";